export default Object.freeze({
    // URL_BASE: 'http://localhost:8080',
    URL_BASE: 'https://api.asman-executive.com',
    API_KEY: 'AIzaSyAGVFhgt8AsuXmx_BOnprrgrORr1_4TIcc'
    // API_KEY: 'AIzaSyBq1l-X4i_mfIsS52oOez16vmrxHiBGW6E'
})
